import { localAxios } from './axios';

export async function getCards() {
  const { data } = await localAxios.get('/api/subscriptions/cards');
  return data;
}
